import Vue from 'vue';
import VueRouter from 'vue-router';
import allColleagues from './all-colleagues';
import auth from './auth';
import errorPages from './error-pages';
import networksInvite from './networks-invite';
import networks from './networks';
import redirects from './redirects';
// import navLinks from './links';
// pages
import Homepage from '../views/Homepage.vue';
import Networks from '../views/Networks.vue';
import SearchResults from '../views/SearchResults.vue';

Vue.use(VueRouter);

const baseRoutes = [
    {
        path: '/home',
        redirect: '/',
    },
    {
        path: '/',
        name: 'homepage',
        component: Homepage,
    },
    {
        path: '/networks',
        name: 'networks',
        component: Networks,
    },
    {
        path: '/search',
        name: 'search',
        component: SearchResults,
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import(/* webpackchunkname: "auth" */ '@/views/Logout.vue'),
    },
    {
        path: '/media',
        name: 'all-media',
        component: () => import(/* webpackchunkname: "networks" */ '@/views/AllMedia.vue'),
    },
    {
        path: '/networks-create',
        name: 'networks-create',
        meta: {
            can: ['network.create'], // enforce requirement that this user must be able to perform this action
        },
        component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/crud/Create.vue'),
    },
    {
        name: 'zoom-redirect',
        path: '/zoom-redirect-endpoint',
        meta: {
            authRequired: true,
        },
        component: () => import('@/views/user/zoom/ZoomRedirect.vue'),
    },
];

// compose the routes.
const routes = baseRoutes.concat(redirects, allColleagues, auth, networksInvite, networks, errorPages);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      }
    } else {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    }
  },
});

router.onError(err => {
  if (err instanceof Error) {
    // this can happen if the user
    if (err.name == 'ChunkLoadError') {
      return window.location.reload();
    }

    alert(err.message);
    console.log('errr', err);
    router.push('/');
  }
});

router.afterEach(() => {
  Vue.bus.emit('hide-mobile-navbar');
});

// TODO we do auth check here,  however the auth/me hasn't been loaded yet, so perhaps vueAuth needs to be called before router is setup.
//
router.beforeEach((to, from, next) => {
  var meta = to.meta;
  var authRequired, roles, can;
  if (meta) {
    authRequired = to.meta.authRequired;
    roles = to.meta.roles;
    can = to.meta.can;
  }

  // if roles or can are defined, we assume you also need to be signed in
  if (roles || can) {
    console.warn('roles||can is true = ASSUMING authRequired=true.');
    authRequired = true;
  }

  // is authRequiredentication required?
  if (authRequired === true) {
    if (localStorage.getItem('token') == null) {
      next({
        name: 'login',
        params: {
          nextUrl: to.fullPath,
        },
      });
    } else {
      let user = JSON.parse(localStorage.getItem('user'));
      console.log('user', user);
      if (roles) {
        console.log('roles', roles);
        return next();
      }
      if (can) {
        console.log('can', can);
        return next();
      }

      return next();
    }
  } else if (authRequired === false) {
    // must be a guess
    if (localStorage.getItem('token') == null) {
      next();
    } else {
      next(new Error('You need to be signed out to access this page'));
    }
  } else if (authRequired === undefined) {
    // don't care if they are signed in or not
    next();
  }
});

Vue.router = router;

export default router;
